<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M31,4.63a2.72,2.72,0,0,1,.35,3.85l-17,19.09a1.32,1.32,0,0,1-1.84.11L.9,17.43a2.71,2.71,0,0,1-.19-3.85,2.75,2.75,0,0,1,3.88-.18L13,20.66,27.15,5A2.75,2.75,0,0,1,31,4.63Z"
    />
</svg>
